module.exports = __webpack_public_path__ + "static/media/back-to-home-page.c47e0c7c.svg";